import { ICameraVideoTrack, ILocalVideoTrack, IRemoteVideoTrack, VideoPlayerConfig } from "agora-rtc-sdk-ng";
import { RefObject, useLayoutEffect, useRef } from "react";

/**
 * Video player. 
 * 
 * This is a copy of AgoraVideoPlayer from agora-rtc-react 
 * https://github.com/AgoraIO-Community/Agora-RTC-React/blob/9a58b065d4f57933c86749620b2b73720424f5b4/src/index.tsx#L397-L408
 * @param props 
 * @returns 
 */
const VideoPlayer = (props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & { videoTrack: ILocalVideoTrack | IRemoteVideoTrack | ICameraVideoTrack | undefined } & {config?: VideoPlayerConfig}) => {
    const { videoTrack, config, ...other } = props;

    const vidDiv: RefObject<HTMLDivElement> = useRef(null)

    useLayoutEffect(() => {
        console.log("Video track", videoTrack)
        if(!videoTrack) return
        if (vidDiv.current !== null) videoTrack.play(vidDiv.current, config)
        return () => {
            videoTrack.stop()
        }
    }, [videoTrack])
  
    return <div {...other} ref={vidDiv} />
}

export default VideoPlayer;
